<template>
    <v-sparkline
      :value="chartValueComputed"
      :gradient="gradient"
      :smooth="radius || false"
      :padding="padding"
      :line-width="width"
      :stroke-linecap="lineCap"
      :gradient-direction="gradientDirection"
      :fill="fill"
      :type="type"
      :auto-line-width="autoLineWidth"
      :labels="chartLabelsComputed"
      :height="80"
      auto-draw
    ></v-sparkline>
  </template>

  <script>
import core from '../../plugins/core';


  const gradients = [
    ['#fbc02d'],
    ['#2196F3'],
    ['red', 'orange', 'yellow'],
    ['purple', 'violet'],
    ['#00c6ff', '#F0F', '#FF0'],
    ['#ffd200', '#1feaea', '#f72047'],
  ]

  export default {
    props: ['chartValues', 'walletMain', 'walletDeposit', 'monyConvertValue', 'inPRT'],
    data: () => ({
        width: 3,
        radius: 10,
        padding: 5,
        lineCap: 'round',
        gradient: gradients[5],
        value: [],
        gradientDirection: 'top',
        gradients,
        fill: false,
        type: 'trend',
        autoLineWidth: false,
    }),
    mounted () {
        this.value = this.chartValues
        this.gradient = this.inPRT ? gradients[0] : gradients[1]
    },
    methods: {
        caclulateValuesWalletMain(){
            this.value = []
            this.walletMain.transactions.forEach(transaction => {
                this.value.push(transaction.amountUnity)
            })
        },
        convertUnityMony(amount, monyConvertValue){
            //console.log("(amount, this.monyConvertValue)", (amount, monyConvertValue))
            return core.convertUnityMony(amount, monyConvertValue)
        },
    },
    computed: {
        chartValueComputed: function(){
            //console.log("chartValueComputed", this.chartValues, this.walletMain)
            if(this.chartValues != null) return this.chartValues
            if(this.walletMain != null) return this.walletMainValues
            if(this.walletDeposit != null) return this.walletDepositValues
            return [0,1]
        },

        chartLabelsComputed: function(){
            //console.log("chartLabelsComputed", this.chartValues, this.walletMain)
            // if(this.chartValues != null) return []
            // if(this.walletMain != null) return this.walletMainLabels
            // return [0,1]
            return []
        },

        walletMainValues: function(){
            let val = []
            let totalUnity = 0
            this.walletMain.transactions.forEach((transaction) => {
                //console.log("monyConvertValue", this.walletMain.uid, transaction.amountUnity, transaction.monyConvertValue)
                totalUnity += transaction.amountUnity 
                let totalMony = this.inPRT === true ? core.convertUnityMony(totalUnity, transaction.monyConvertValue) : totalUnity
                val.push(totalMony)
                //console.log("totalMony", totalMony)
            })
            return val
        },
        walletMainLabels: function(){
            let lbls = []
            let val = []
            let totalUnity = 0
            this.walletMain.transactions.forEach((transaction) => {
                //console.log("walletMainLabels", transaction.amountUnity, i)
                //console.log("monyConvertValue", this.walletMain.uid, transaction.amountUnity, transaction.monyConvertValue)
                totalUnity += transaction.amountUnity 
                let totalMony = this.inPRT === true ? core.convertUnityMony(totalUnity, transaction.monyConvertValue) : totalUnity
                val.push(totalMony)
                lbls.push(totalMony.toFixed(2))
                //console.log("lbls totalMony", totalMony)
            })
            return lbls
        },


        walletDepositValues: function(){
            let val = []
            let totalMony = 0
            this.walletDeposit.transactions.forEach((transaction) => {
                //console.log("CHART DEPOSIT", this.walletDeposit.uid, transaction.amountMony, transaction.monyConvertValue)
                totalMony += transaction.amountMony
                val.push(totalMony)
                //console.log("totalMony", totalMony)
            })
            return val
        },
    },
    watch: {
        
        'chartValues': { immediate: true, 
            async handler () {
                this.value = this.chartValues
            }
        },
    }
  }

</script>